/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { SPEEDS, usePlayerSpeedIndex } from "@packages/media";
import { ModalTab, SpeedIcon } from "@packages/ui";
import { HallowDataTestId } from "@tools/playwright/global";

import { useMediaAnalyticsProps } from "../../../../hooks/useMediaAnalyticsProps";
import type { MediaMenuTabProps } from "../MediaMenu.emotion";

export const SelectPlaybackSpeedTab = ({ disabled }: MediaMenuTabProps) => {
  const { currentIdx } = usePlayerSpeedIndex();
  const t = useTranslations();
  const { track } = useAnalytics();
  const analyticsProps = useMediaAnalyticsProps();

  return (
    <ModalTab
      key={"speedSelectMenuTab"}
      value={"speedSelectMenu"}
      data-testid={HallowDataTestId.MediaSettingsTab}
      label={t("track_settings_playback_speed")}
      startIcon={<SpeedIcon />}
      disabled={disabled}
      onClick={() =>
        track({
          event: HallowAnalyticsEvent.TappedPlaybackSpeed,
          properties: analyticsProps,
        })
      }
    >
      {t("web_audio_player_speed", { "0": SPEEDS[currentIdx] })}
    </ModalTab>
  );
};
